<template>
  <default-dialog
    v-model="value"
    width="95%"
    max-width="1200px" max-height="90%"
    @accepted="accepted($event)"
    @closing="closing($event) /* transmit event upward */"
    :label_accept="label_accept"
  >

    <template #header>

      <span>{{label_accept}} plate</span>

      <!-- state (inputs) -->
      <v-spacer></v-spacer>

      <v-tooltip left>
        <template #activator="{ on }">
          <v-icon v-on="on"> mdi-cog</v-icon>
        </template>
        <template #default>
          <pre> {{ JSON.stringify(state, null, 2) }} </pre>
        </template>
      </v-tooltip>
    </template>

    <template #content>

      <v-layout row fill-height>

        <!-- Left pane (name, instrument etc) -->
        <v-flex xl4 lg4 md5 xs12 style="padding: 8px;">
          <v-layout row style="">

            <!-- name -->
            <v-flex sm6 md12 style="padding: 8px;">
              <v-text-field
                ref="txtName" v-model="inputs.name"
                label="Plate name" outlined dense hide-details clearable/>
            </v-flex>

            <!-- instrument -->
            <v-flex sm6 md12 style="padding: 8px;">
              <v-select
                v-model="inputs.instrument" :items="instrument_list"
                item-text="name"
                item-value="id"
                label="Instrument" outlined dense hide-details/>
            </v-flex>

            <!-- projects -->
            <v-flex sm12 md12 style="padding: 8px;">
              <project-selector
                ref="ctrlProjectSelector"
                v-model="inputs.projects"
                :second="inputs.projects"
                height="226px"
              >
              </project-selector>
            </v-flex>

            <!-- flags -->
            <v-flex sm12 md12>
              <plate-flags
                ref="ctrlPlateFlags"
                :value="inputs"
                @input="ctrlPlateFlags_input"
              >
              </plate-flags>
            </v-flex>

          </v-layout>
        </v-flex>

        <!-- Right pane (file from storage) -->
        <v-flex xl8 lg8 md7 xs12 style="padding: 8px;">
          <v-layout row fill-height>

            <!-- Storage select -->
            <v-flex xs12 sm12 md12 style="padding: 8px;">
              <v-layout fluid style="vertical-align: middle;">
                <v-flex xl12>
                  <v-select
                    v-model="inputs.storage" clearable
                    label="Storage" dense outlined hide-details
                    :items="storage_list"
                    item-value="id" item-text="name">
                  </v-select>
                </v-flex>
                <!-- Refresh button -->
                <v-tooltip right open-delay="600ms">
                  <template #activator="{ on }">
                    <v-btn icon v-on="on"
                           style="margin-left: 8px; margin-top: 2px;"
                           :disabled="inputs.storage === null"
                           @click="btnRefresh_click($event)">
                      <v-icon>refresh</v-icon>
                    </v-btn>
                  </template>
                  <template #default>
                    <span>Refresh storage tree</span>
                  </template>
                </v-tooltip>

              </v-layout>
            </v-flex>

            <!-- Storage files -->
            <v-flex xs12 sm12 md12 style="padding: 8px;">
              <div style="">
                <storage-file-selector
                  ref="ctrlStorageSelectFile"
                  :storage="inputs.storage"
                  v-model="inputs.file_new"
                  height="350px"
                >
                </storage-file-selector>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xl12 lg12 md12 xs12 style="padding:4px;">
          <v-text-field
            v-model="inputs.file_new"
            outlined dense hide-details label="Storage file"
          >
          </v-text-field>
        </v-flex>

        <!-- notes -->
        <v-flex xl12 lg12 md12 xs12 style="margin-top:16px;">
          <notes-editor
            v-model="inputs.notes" label="Notes"
            style="margin-left: 4px; margin-right: 4px;">
          </notes-editor>
        </v-flex>

        <!--        <v-flex xl12>-->
        <!--          <v-text-field-->
        <!--            v-model="plate.file" placeholder="File"-->
        <!--            disabled dense outlined hide-details-->
        <!--            style="margin: 16px;">-->
        <!--          </v-text-field>-->
        <!--        </v-flex>-->

      </v-layout>

    </template>

    <template slot="actions">
      <v-col>
        <v-btn @click.native="btnClear_click()">Clear</v-btn>
      </v-col>
    </template>

  </default-dialog>

</template>

<script>
	import format from 'string-format'

	import FileBrowser from 'vuetify-file-browser'
	import DefaultDialog from "../DefaultDialog"
	import NotesEditorComponent from "../NotesEditorComponent"
	import StorageFileSelectorComponent from "../storage/StorageFileSelectorComponent"
	import PlateFlagsComponent from "../plate/PlateFlagsComponent"

	import {mapActions, mapGetters} from 'vuex'
	import {Plate} from "../../models"
	import ProjectSelectorComponent from "../project/ProjectSelectorComponent"

	export default {
		name: "plate-props-dialog",
		components: {
			DefaultDialog,
			'project-selector': ProjectSelectorComponent,
			NotesEditorComponent,
			FileBrowser,
			'storage-file-selector': StorageFileSelectorComponent,
			'plate-flags': PlateFlagsComponent,
		},

		data: function () {
			return {
				inputs: {
					id: null,
					name: null,
					projects: [],
					instrument: null,
					notes: "",
					storage: null,
					file: null,
					file_new: null,
					extra: false,
					failed: false,
					ready: false,
				},
			}
		},

		props: {
			value: {type: Boolean, default: false,},

			// тип plate может быть Object для маленьких объектов из списка планшет,
			// или класс Plate для большого объекта из PlateView
			plate: {type: Object, default: () => Plate.empty_plate},

			new: {type: Boolean, default: false,},
		},

		watch: {
			value: function () {
				// TODO: фокус на поле ввода
				console.debug(format(
					"PlatePropsDialog.watch.value()\n" +
					"  {0}",
					JSON.stringify({'inputs.projects': this.inputs.projects})))
			},

			plate: function () {
				for (let field_name in this.inputs) {
					this.inputs[field_name] = this.plate != null && field_name in this.plate
						? this.plate[field_name]
						: null
				}
				this.inputs.file_new = this.inputs.file

				console.debug(format(
					"PlatePropsDialog.watch.plate()\n" +
					"  {0}",
					JSON.stringify({"inputs.storage": this.inputs.storage})))
			},

			'inputs.file_new': function () {
				console.debug(format(
					"PlatePropsDialog.watch.inputs.file_new( {0} )",
					this.inputs.file_new))

				if (!this.inputs.name && this.inputs.file_new) {
					this.inputs.name = this.inputs.file_new
						.split('/').slice(-1)[0]
						.split('.').slice(0, -1).join('.')
						.replace('_', ' ')
				}
			},

			'inputs.projects': function () {
				console.debug(format(
					"PlatePropsDialog.watch.'inputs.projects'( {0} )",
					JSON.stringify(this.inputs.projects)))
			},
		},

		computed: {

			...mapGetters({
				instrument_list: 'lists/instrument_list',
				storage_list: 'storage/storage_list',

			}),

			label_accept: function () {
				return this.new ? "Create" : "Update"
			},

			state: function () {
				return {
					inputs: this.inputs,
					'plate.ctor.name': this.plate.constructor.name,
				}
			},
		},

		mounted: function () {
			console.debug(format(
				"PlatePropsDialog.mounted()\n" +
				"  {0}",
				JSON.stringify({'inputs.projects': this.inputs.projects})))
		},

		methods: {
			...mapActions({
				plate_update_plate: 'plate/update_plate',
				plate_create_plate: 'plate/create_plate',

				message_add: 'message/add',
				progress_begin: 'progress/begin',
				progress_end: 'progress/end',
			}),

			cleanup_data: function (val) {
				// Если пользователь не загрузил новый файл,
				// то не будем передавать его в объекте.
				let obj = {}

				for (let key in val) {
					obj[key] = val[key]
				}

				obj.file = obj.file_new
				if (!obj.file) {
					delete obj.file
				}
				delete obj.file_new

				// -1 - All projects does not exist
				obj.projects = val.projects.filter(p_id => p_id !== -1)

				if (this.new) {
					delete obj.id
				}

				return obj
			},

			// -- Handle controls' events --

			btnClear_click: function (e) {
				this.inputs.storage = null
			},

			ctrlPlateFlags_input: function (value) {
				console.log(format(
					"PlateAddDialog.ctrlPlateFlags_input( {0} )",
					JSON.stringify(value)))
				for (let key in value) {
					this.inputs[key] = value[key]
				}
			},

			btnRefresh_click: function (event) {
				console.debug("StorageSelectFileComponent.btnRefresh_click()")
				this.$refs.ctrlStorageSelectFile.update_storage_treeview(true)
			},

			/**
			 * Обработчик события, нажатия пользователем кнопки Ok.
			 * @param event
			 */
			accepted: function (event) {
				// TODO: тут можно какие-то данные поменять
				event.inputs = this.cleanup_data(this.inputs)
				this.$emit('accepted', event)
			},

			closing: function (event) {
				this.$emit('closing', event)
			},
		},
	}
</script>

<style scoped>

</style>